<div [kalLoading]="loading">

    <kal-select
        *ngIf="administrativeStatusList | arrayNotEmpty"
        [formControl]="formControl"
        [placeholder]="placeholderValue"
        [multiple]="multiple">

        <kal-option
            *ngFor="let value of filteredAdministrativeStatusList"
            [value]="value.IsStatutPerso ? value.IdStatut : value.CodeStatut">
            <span [style.text-indent.em]="value.IsStatutPerso ? 1 : 0">
                {{ value.LibelleStatut }}
            </span>
        </kal-option>
    </kal-select>

</div>
